 /* 
 * DRAWER SLIDER 
 * Implemented: sections/main-product.liquid
 */

window.addEventListener("DOMContentLoaded", initDrawer);

function initDrawer() {
  const togglers = document.querySelectorAll("[data-js-element='drawer']");

  if (!togglers) {
    return console.log("Drawers does not exists");
  }

  togglers.forEach((toggler) =>
    toggler.addEventListener("click", handleDrawer)
  );
}

function handleDrawer(e) {
  const { drawerContent } = e.currentTarget.dataset;
  console.log(drawerContent);

  if (!drawerContent) {
    return console.log("Drawers toggler does not exists");
  }

  //open drawer based on drawer content
  const drawer = document.querySelector(`[data-drawer-for=${drawerContent}]`);
  console.log("draw", drawer);

  if (!drawer) {
    return console.log("Drawers content does not exists");
  }

  drawer.classList.toggle("show");

  // Backdrop open
  const backdrop = document.querySelector("[data-js-backdrop]");
  if (!backdrop) {
    return console.log("Drawer backdrop does not exits.");
  }

  backdrop?.classList.toggle("op-0");

  backdrop.addEventListener(
    "click",
    (e) => {
      e.stopPropagation();
      e.currentTarget?.classList.toggle("op-0");
      drawer.classList.toggle("show");
    },
    { once: true }
  );

  // Closing drawer btns
  const drawerCloseBtns = document.querySelectorAll(
    `[data-drawer-for=${drawerContent}] .close-drawer`
  );
  drawerCloseBtns?.forEach((btn) =>
    btn?.addEventListener("click", () => {
      drawer.classList.remove("show");
      backdrop?.classList.add("op-0");
    })
  );
}

